module.exports = __webpack_public_path__ + "static/media/avatar-01@3x.485f84e2.png";